import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * A largura de um elemento, acompanhada pelo `ResizeObserver`. Devolve o `ref` (callback) para pôr
 * no elemento e a largura em pixels. Zero = ainda não medido — e nos testes, onde o jsdom não
 * mede nada.
 */
export function useLarguraDoElemento<T extends HTMLElement>(): [(elemento: T | null) => void, number] {
  const [largura, setLargura] = useState(0);
  const observador = useRef<ResizeObserver | null>(null);

  const ref = useCallback((elemento: T | null) => {
    observador.current?.disconnect();
    observador.current = null;
    if (!elemento) return;
    const medir = () => setLargura(Math.round(elemento.getBoundingClientRect().width));
    medir();
    if (typeof ResizeObserver === 'undefined') return;
    observador.current = new ResizeObserver(medir);
    observador.current.observe(elemento);
  }, []);

  useEffect(() => () => observador.current?.disconnect(), []);
  return [ref, largura];
}
